import styled from 'styled-components';
import {
  fontSize,
  FontSizeProps,
  fontWeight,
  FontWeightProps,
  textAlign,
  TextAlignProps,
  margin,
  MarginProps,
  lineHeight,
  LineHeightProps,
  fontFamily,
  FontFamilyProps,
  letterSpacing,
  LetterSpacingProps
} from 'styled-system';

export const Text = styled.p<
  FontSizeProps &
    FontWeightProps &
    TextAlignProps &
    MarginProps &
    LineHeightProps &
    FontFamilyProps &
    LetterSpacingProps & { color?: string }
>`
  margin: 0;
  color: ${({ color = 'var(--dark-brown)' }) => color};
  ${fontSize}
  ${fontWeight}
  ${textAlign}
  ${margin}
  ${lineHeight}
  ${fontFamily}
  ${letterSpacing}
`;
